import React from 'react';
import Loader from '@/components/common/Loader';
import translate from '@/lib/intl/translate';
import AutomationType from '../constants/AutomationType';
import useMajorGiftAutomations from '../hooks/useMajorGiftAutomations';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import AutomationsListItem from './AutomationsListItem';

type SortedData = {
  [key in AutomationType]: { label: string; items: MajorGiftAutomation[] };
};

const getSortedData = (data: MajorGiftAutomation[]) => {
  const result = Object.values(AutomationType).reduce(
    (obj, type) => ({
      ...obj,
      [type]: {
        label: translate(`AUTOMATIONS_${type.toUpperCase()}_SECTION`),
        items: [],
      },
    }),
    {},
  ) as SortedData;
  data.forEach((item) => {
    result[item.type].items.push(item);
  });
  return result;
};

function AutomationsList() {
  const { data } = useMajorGiftAutomations();

  const sortedData = React.useMemo(() => getSortedData(data || []), [data]);

  if (!data) {
    return <Loader isCentered className="w-full" />;
  }

  if (!data.length) {
    return (
      <div className="flex flex-col items-center pt-3 text-center">
        <h3 className="type-h3">{translate('AUTOMATIONS_NO_ITEMS')}</h3>
        <div className="my-4 w-32 border-b border-text-disabled" />
        <div className="text-text-secondary">
          {translate('AUTOMATIONS_CREATE_ONE')}
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6">
      {Object.values(sortedData).map(({ label, items }) =>
        items.length ? (
          <div key={label} className="mb-6">
            <h3 className="mb-4 type-body2">{label}</h3>
            <ul className="flex flex-col gap-4">
              {items.map((item) => (
                <AutomationsListItem
                  key={item.automationId}
                  automation={item}
                />
              ))}
            </ul>
          </div>
        ) : null,
      )}
    </div>
  );
}

export default AutomationsList;
